export default {
  name: 'executionRecord',
  data () {
    return {
      page: {
        num: 1,
        size: 10
      },
      totalRows: 100,
      labelPosition: 'right',
      formInline: {
        taskName: '',
        sysId: '',
        execStatus: ''
      },
      tooltip: true,
      statusData: [
        {
          id: 1,
          value: '执行成功'
        },
        {
          id: 2,
          value: '执行失败'
        },
        {
          id: 3,
          value: '执行中'
        }
      ],
      tableList: []
    }
  },
  created () {
    this.$store.dispatch('getSystem') // 请求业务系统
    this.queryList()
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    /* 表格状态值转换 */
    taskStatus (row) {
      if (row.execStatus == '1') {
        return '执行成功'
      } else if (row.execStatus == '2') {
        return '执行失败'
      } else if (row.execStatus == '3') {
        return '执行中'
      }
    },
    /* 查询执行记录列表 */
    queryList () {
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size,
        sysIds: sysIds,
        execStatus: this.formInline.execStatus,
        taskName: this.formInline.taskName
      }
      let _self = this
      this.$axios
        .post(this.$API.tasksched.queryExecHistList, params)
        .then(function (r) {
          _self.tableList = r.data.resData.resultList
          _self.totalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* 点击查询按钮 */
    onSearch () {
      this.page.num = 1
      this.queryList()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
    },
    /* 重新执行 */
    reExecution (index, row) {
      console.log(row)
      let params = {
        recordId: row.recordId
      }
      this.$confirm('确认是否重新执行失败任务？', '重新执行', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let _self = this
          this.$axios
            .post(this.$API.tasksched.rerunSchedTask, params)
            .then(function (r) {
              _self.$message({
                type: 'success',
                message: '执行成功'
              })
              _self.queryList()
            })
            .catch(function (error) {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.size = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/timedTask/executionRecord.js